import { CheckoutMixpanelEvent } from 'types/checkout';
import { investmentEntity } from '@store/modules/investment-entity';
import { orderForm } from '@store/modules/order-form';
import { trackMixpanel } from './analytics';

export const buildCheckoutMixpanelProperties = (): CheckoutMixpanelEvent => {
	const properties: CheckoutMixpanelEvent = {
		'Order Type': 'RIA',
		'RIA Plan': orderForm.plan?.name || ''
	};

	if (orderForm.orderGroupId) {
		properties['Investment Amount'] = orderForm.investmentAmount;
		properties['Entity Type'] = investmentEntity.entityTypeLabel;
		properties['Transaction Type'] = 'ACH';
		properties['Investments'] = orderForm.investments;
		if (orderForm.paymentMethodSetup) {
			properties['Payment Method Setup'] = orderForm.paymentMethodSetup;
		}
		if (orderForm.paymentMethodCreationMethod) {
			properties['Payment Method Creation Method'] = orderForm.paymentMethodCreationMethod;
		}
	}

	return properties;
};

export const sendCheckoutMixpanel = (eventName: string): void => {
	const properties: CheckoutMixpanelEvent = buildCheckoutMixpanelProperties();

	trackMixpanel(eventName, properties);
};
